import path from 'path-browserify';
import { getRemoteIconPath } from './getRemoteIconPath';
import { canRouteBeUsed } from './route-availability';
/**
 * Generates a RouteConfig using remote module information.
 *
 * @param routeProps remote module routes info
 * @param filterProps the state info needed for filtering
 * @param basePath the URL path where the remote module's root will be rendered
 * @returns a RouteConfig mapped from the remote module info
 */
export const generateRouteConfig = (routeProps, filterProps, basePath, remoteUrl) => {
    const routes = routeProps.routes
        ? routeProps.routes
            ?.filter((route) => canRouteBeUsed(route, filterProps))
            .map((route) => generateSubRouteConfig(route, filterProps, path.join(basePath, route.path), remoteUrl))
        : undefined;
    return {
        ...routeProps,
        usage: 'sidebar',
        path: basePath,
        ...(routes && { routes }),
    };
};
export const generateSubRouteConfig = (routeProps, filterProps, basePath, remoteUrl) => {
    const routes = routeProps.routes
        ? routeProps.routes
            ?.filter((route) => canRouteBeUsed(route, filterProps))
            .map((route) => generateSubRouteConfig(route, filterProps, path.join(basePath, route.path), remoteUrl))
        : undefined;
    return {
        ...routeProps,
        usage: routeProps.usage ?? 'simple',
        path: basePath,
        ...(routeProps.usage === 'sidebar' &&
            routeProps.iconPath && {
            iconPath: getRemoteIconPath(remoteUrl, routeProps.iconPath),
        }),
        ...(routes && { routes }),
    };
};
